import React, { useState } from 'react';
import styled from 'styled-components';
import FooterComponent from './FooterComponent.js';
import HeaderComponent from './HeaderComponent.js';
import HomePage from './HomePage.js';
import ProcessPage from './ProcessPage.js';
import PodcastPage from './PodcastPage.js';
import FreeGiftsPage from './FreeGiftsPage.js';
import ContactPageComponent from './ContactPage.js';

// Styled Components
const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
`;

// Main App Component
const Hatmada = () => {
  const [currentPage, setCurrentPage] = useState('home');

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage />;
      case 'free-gifts':
        return <FreeGiftsPage />;
      case 'process':
        return <ProcessPage />;
      case 'podcast':
        return <PodcastPage />;
      case 'contact':
        return <ContactPageComponent />;
      default:
        return <HomePage />;
    }
  };

  return (
    <Container>
      <HeaderComponent currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <Main>
        {renderPage()}
      </Main>
      <FooterComponent setCurrentPage={setCurrentPage} />
    </Container>
  );
};

export default Hatmada;